import {t} from "./i18n.js"

// CodeMirror owns search, folding and assistive announcements outside the LiveView DOM.
export function codeMirrorPhrases() {
  return {
    "Find": t("Find"),
    "Replace": t("Replace"),
    "next": t("Next"),
    "previous": t("Previous"),
    "all": t("All"),
    "match case": t("Match case"),
    "regexp": t("Regular expression"),
    "by word": t("Whole words"),
    "replace": t("Replace"),
    "replace all": t("Replace all"),
    "close": t("Close"),
    "Go to line": t("Go to line"),
    "go": t("Go"),
    "replaced match on line $": t("Replaced match on line $"),
    "replaced $ matches": t("Replaced $ matches"),
    "current match": t("Current match"),
    "on line": t("On line"),
    "Folded lines": t("Folded lines"),
    "Unfolded lines": t("Unfolded lines"),
    "to": t("to"),
    "folded code": t("Folded code"),
    "unfold": t("Unfold"),
    "Fold line": t("Fold line"),
    "Unfold line": t("Unfold line"),
    "Completions": t("Completions"),
    "Control character": t("Control character"),
    "Diagnostics": t("Diagnostics"),
    "No diagnostics": t("No diagnostics"),
    "Selection deleted": t("Selection deleted"),
  }
}
